import React, { useEffect, useRef, useState } from "react";
import { Button, Dropdown, DropdownHeader, DropdownItem } from "flowbite-react";
import {
  HiChartPie,
  HiCog,
  HiPresentationChartLine,
  HiClipboardList,
  HiChevronDown,
  HiOutlineLightBulb,
  HiOutlineUser,
  HiOutlineLogout,
  HiOutlineX,
} from "react-icons/hi";
import { Link, useLocation } from "react-router-dom";
import images from "../assets/images";
import { MdOutlineShoppingCart } from "react-icons/md";

export const SidebarComponent = ({
  isOpen,
  onToggleSidebar,
  setOpenModal,
  loginData,
  tabs,
}) => {
  const location = useLocation();
  const elemRef = useRef();
  const isActive = (path) => location.pathname === path;
  const [activeDropdown, setActiveDropdown] = useState(null);
  const [isHovered, setIsHovered] = useState(null);

  const handleDropClick = (menuName) => {
    setActiveDropdown((prev) => (prev === menuName ? null : menuName));
  };
  const handleToggle = () => {
    onToggleSidebar();
  };
  const handleMouseEnter = () => setIsHovered(true);
  const handleMouseLeave = () => setIsHovered(false);

  useEffect(() => {
    const element = elemRef.current;
    if (!element) return;

    if (!isOpen) {
      setIsHovered(false);
      element.removeEventListener("mouseenter", handleMouseEnter);
      element.removeEventListener("mouseleave", handleMouseLeave);
    } else {
      const timeout = setTimeout(() => {
        element.addEventListener("mouseenter", handleMouseEnter);
        element.addEventListener("mouseleave", handleMouseLeave);
      }, 500);

      return () => {
        clearTimeout(timeout);
        element.removeEventListener("mouseenter", handleMouseEnter);
        element.removeEventListener("mouseleave", handleMouseLeave);
      };
    }
  }, [isOpen]);

  const canRender = (item) =>
    loginData?.role === "User" ? item?.has_access : true;

  return (
    <div
      className={`sticky top-0 peer w-auto collapseSide sidebar transition-all duration-300 h-screen z-10 
        ${
          isOpen && (!isHovered || window.innerWidth <= 1024)
            ? "collapseSide-closed"
            : "collapseSide-open"
        }`}
      ref={elemRef}
    >
      {/* Logo + collapse button */}
      <div className="sidebar-logo mb-4 overflow-hidden">
        <div className="flex justify-between items-center w-full">
          <div className="flex gap-2">
            <img src={images.IrisLogo} alt="Iris" className="logoSec" />
            <span>Ultra Iris</span>
          </div>
          {window.innerWidth <= 1024 && (
            <button
              type="button"
              className="sidebar-cross"
              onClick={handleToggle}
            >
              <HiOutlineX />
            </button>
          )}
        </div>
        <Button onClick={handleToggle} className="menuBtn mt-1">
          {isOpen ? (
            <img
              src={images.RightDoor}
              alt="icons"
              className="hover:opacity-70"
            />
          ) : (
            <img
              src={images.LeftDoor}
              alt="icons"
              className="hover:opacity-70"
            />
          )}
        </Button>
      </div>

      <div className="flex flex-col h-full justify-between menuSec">
        {/* ===== Top Menu ===== */}
        <div className="upperMenu">
          <ul className="menu">
            {/* Account Audit */}
            {canRender(tabs?.[0]) && (
              <li
                className={`menu-item has-dropdown ${
                  activeDropdown === "accountAudit" ? "open" : ""
                }`}
              >
                <div
                  className="menu-item-btn"
                  onClick={() => handleDropClick("accountAudit")}
                >
                  <i className="icon">
                    <HiChartPie />
                  </i>
                  <span className="text">Account Audit</span>
                  <HiChevronDown className="arrow" />
                </div>
                <ul className="submenu">
                  <li>
                    <Link className="link-name">Account Audit</Link>
                  </li>
                  {canRender(tabs?.[0]?.sub_tabs?.[0]) && (
                    <li>
                      <Link
                        className={`sidebar-a ${
                          isActive("/audit-report") ? "active" : ""
                        }`}
                        to="/audit-report"
                      >
                        Meta Ads
                      </Link>
                    </li>
                  )}
                  {canRender(tabs?.[0]?.sub_tabs?.[1]) && (
                    <li>
                      <Link
                        className={`sidebar-a ${
                          isActive("/google-audit") ? "active" : ""
                        }`}
                        to="/google-audit"
                      >
                        Google Ads
                      </Link>
                    </li>
                  )}
                </ul>
              </li>
            )}

            {/* Planning */}
            {canRender(tabs?.[1]) && (
              <li
                className={`menu-item ${
                  isActive("/media-planning") ? "active" : ""
                }`}
              >
                <Link className="menu-item-btn" to="/media-planning">
                  <i className="icon">
                    <HiClipboardList />
                  </i>
                  <span className="text">Planning</span>
                </Link>
                <ul className="submenu blank">
                  <li>
                    <Link className="link-name" to="/media-planning">
                      Planning
                    </Link>
                  </li>
                </ul>
              </li>
            )}

            {/* Optimization AI */}
            {canRender(tabs?.[2]) && (
              <li
                className={`menu-item has-dropdown ${
                  activeDropdown === "optimization" ? "open" : ""
                }`}
              >
                <div
                  className="menu-item-btn"
                  onClick={() => handleDropClick("optimization")}
                >
                  <i className="icon">
                    <HiCog />
                  </i>
                  <span className="text">Optimization AI</span>
                  <HiChevronDown className="arrow" />
                </div>
                <ul className="submenu">
                  <li>
                    <Link className="link-name">Optimization AI</Link>
                  </li>
                  {canRender(tabs?.[2]?.sub_tabs?.[0]) && (
                    <li>
                      <Link
                        className={`sidebar-a ${
                          isActive("/optimization-status") ? "active" : ""
                        }`}
                        to="/optimization-status"
                      >
                        Status
                      </Link>
                    </li>
                  )}
                  {canRender(tabs?.[2]?.sub_tabs?.[1]) && (
                    <li>
                      <Link
                        className={`sidebar-a ${
                          isActive("/active-take-off") ? "active" : ""
                        }`}
                        to="/active-take-off"
                      >
                        Take Off
                      </Link>
                    </li>
                  )}
                  {canRender(tabs?.[2]?.sub_tabs?.[2]) && (
                    <li>
                      <Link
                        className={`sidebar-a ${
                          isActive("/optimization-co-pilot") ? "active" : ""
                        }`}
                        to="/optimization-co-pilot"
                      >
                        Co-Pilot
                      </Link>
                    </li>
                  )}
                </ul>
              </li>
            )}

            {/* Creative AI */}
            {canRender(tabs?.[4]) && (
              <li
                className={`menu-item ${
                  isActive("/creative-ai") ? "active" : ""
                }`}
              >
                <Link className="menu-item-btn" to="/creative-ai">
                  <i className="icon">
                    <HiOutlineLightBulb />
                  </i>
                  <span className="text">Creative AI</span>
                </Link>
                <ul className="submenu blank">
                  <li>
                    <Link className="link-name" to="/creative-ai">
                      Creative AI
                    </Link>
                  </li>
                </ul>
              </li>
            )}

            {/* Audience AI */}
            {canRender(tabs?.[5]) && (
              <li
                className={`menu-item ${isActive("/audience") ? "active" : ""}`}
              >
                <Link className="menu-item-btn" to="/audience">
                  <i className="icon">
                    <HiOutlineUser />
                  </i>
                  <span className="text">Audience AI</span>
                </Link>
                <ul className="submenu blank">
                  <li>
                    <Link className="link-name" to="/audience">
                      Audience AI
                    </Link>
                  </li>
                </ul>
              </li>
            )}

            {/* Campaign Analytics */}
            {canRender(tabs?.[3]) && (
              <li
                className={`menu-item ${
                  isActive("/campaign-analytics") ? "active" : ""
                }`}
              >
                <Link className="menu-item-btn" to="/campaign-analytics">
                  <i className="icon">
                    <HiPresentationChartLine />
                  </i>
                  <span className="text">Campaign Analytics</span>
                </Link>
                <ul className="submenu blank">
                  <li>
                    <Link className="link-name" to="/campaign-analytics">
                      Campaign Analytics
                    </Link>
                  </li>
                </ul>
              </li>
            )}

            {/* Feed Manager */}
            {canRender(tabs?.[6]) && (
              <li
                className={`menu-item has-dropdown ${
                  activeDropdown === "FeedManager" ? "open" : ""
                }`}
              >
                <div
                  className="menu-item-btn"
                  onClick={() => handleDropClick("FeedManager")}
                >
                  <i className="icon">
                    <MdOutlineShoppingCart />
                  </i>
                  <span className="text">Feed Manager</span>
                  <HiChevronDown className="arrow" />
                </div>
                <ul className="submenu">
                  <li>
                    <Link className="link-name">Feed Manager</Link>
                  </li>
                  {canRender(tabs?.[6]?.sub_tabs?.[0]) && (
                    <li>
                      <Link
                        className={`sidebar-a ${
                          isActive("/feed-setting") ? "active" : ""
                        }`}
                        to="/feed-setting"
                      >
                        Feed Settings
                      </Link>
                    </li>
                  )}
                  {canRender(tabs?.[6]?.sub_tabs?.[1]) && (
                    <li>
                      <Link
                        className={`sidebar-a ${
                          isActive("/catalogue-list") ? "active" : ""
                        }`}
                        to="/catalogue-list"
                      >
                        Catalogue List
                      </Link>
                    </li>
                  )}
                  {canRender(tabs?.[6]?.sub_tabs?.[2]) && (
                    <li>
                      <Link
                        className={`sidebar-a ${
                          isActive("/product-statistics") ? "active" : ""
                        }`}
                        to="/product-statistics"
                      >
                        Product Statistics
                      </Link>
                    </li>
                  )}
                </ul>
              </li>
            )}
          </ul>
        </div>

        {/* ===== Bottom Menu ===== */}
        <div className="bottomMenu">
          <div>
            <ul className="menu">
              {loginData?.role !== "User" && (
                <li className="menu-item">
                  <Link className="menu-item-btn" to="/configure">
                    <i className="icon">
                      <HiCog />
                    </i>
                    <span className="text">Settings</span>
                  </Link>
                  <ul className="submenu blank">
                    <li>
                      <Link className="link-name" to="/configure">
                        Settings
                      </Link>
                    </li>
                  </ul>
                </li>
              )}
            </ul>

            {/* Avatar + Dropdown */}
            <div className="pt-2 mt-2 border-t border-neutral-200 flex gap-3 items-center logOutSec">
              <Dropdown
                renderTrigger={() => (
                  <button className="flex items-center gap-2 px-2">
                    <div className="flex items-center justify-center w-8 h-8 bg-blue-700 text-white text-base font-semibold rounded-full">
                      <span>
                        {loginData?.name
                          ?.split(" ")
                          .map((n) => n[0])
                          .join("")
                          .substring(0, 2)
                          .toUpperCase()}
                      </span>
                    </div>
                    <div className="avtarContent">
                      <div className="mb-0.5 text-sm font-semibold leading-none text-gray-900 dark:text-white peer-has-[collapseSide]:hidden">
                        {loginData?.name}
                      </div>
                      <div className="text-xs text-left text-gray-500 dark:text-gray-400">
                        {loginData?.role}
                      </div>
                    </div>
                  </button>
                )}
              >
                <DropdownHeader>
                  <div className="text-sm font-semibold leading-none text-gray-900 dark:text-white mb-1">
                    {loginData?.name}
                  </div>
                  <span className="text-xs text-left text-gray-500 dark:text-gray-400 block truncate">
                    {loginData?.email}
                  </span>
                </DropdownHeader>
                {/* <DropdownItem>
                  <Link
                    className="flex items-center gap-3"
                    to="/change-password"
                  >
                    Change Password
                  </Link>
                </DropdownItem>
                <div className="my-1 h-px bg-gray-100 dark:bg-gray-600"></div> */}
                <DropdownItem
                  className="text-red-600"
                  onClick={() => setOpenModal(true)}
                >
                  <HiOutlineLogout className="mr-2 text-lg" /> Sign Out
                </DropdownItem>
              </Dropdown>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
